export const Storage = {
  // Alerts
  ERROR_ALERT: 'usFlashErrorMessage',
  SUCCESS_ALERT: 'usFlashSuccessMessage',

  // Booleans
  GIFT_CARD_SUCCESS: 'giftCardSuccess',
  JUST_BROWSING: 'justBrowsing',
  REVIEW_FAQ_SHOWN: 'reviewFaqShown',
  SKIP_ACCESS_CHECK: 'skipAccessCheck',
  SKIP_BENEFITS_CHECK: 'skipBenefitsCheck',
  SHOW_NUX_SAVED_SEARCH_MODAL: 'showNuxSavedSearchModal',
  SOCIAL_CONFIRMED: 'socialInfoConfirmed',
  TRUE: 'true',
  SAVED_SEARCH_DATA: 'savedSearchData',

  // Data
  AGENCY_BOOKING_SUCCESS: 'agencyBookingSuccess',
  AGENCY_CITY: 'agencyCity',
  AGENCY_END_DATE: 'agencyEndDate',
  AGENCY_NUM_CHILDREN: 'agencyNumberOfChildren',
  AGENCY_START_DATE: 'agencyStartDate',
  AGENCY_STATE: 'agencyState',
  AGENCY_STREET: 'agencyStreet',
  AGENCY_ZIP: 'agencyZipCode',
  COMPANY_EMPLOYEE: 'companyEmployee',
  COMPANY_ID: 'companyId',
  COMPANY_EMAIL: 'companyEmail',
  COMPANY_EXTERNAL_ID: 'companyExternalId',
  COMPANY_VALIDATION: 'companyValidation',
  BOOKING_ORIGIN: 'bookingSource',
  BRANCH_DATA_KEY: 'us_branch_io_data',
  FAMILY_REGISTRATION_STORE: 'FamilyRegistrationStore',
  GEOCODE_DATA_KEY: 'geocodeData',
  NPS_FEEDBACK_SOURCE: 'NPS_FEEDBACK_SOURCE',
  NPS_PROMPT_ID: 'NPS_PROMPT_ID',
  ONE_TWO_PUNCH: 'bookingSuccessPromo',
  ORIGINAL_USER_ID: 'ORIGINAL_USER_ID',
  PAYWALL_SOURCE: 'paywallSource',
  RECURRING_SUCCESS: 'recurringBookingSuccess',
  SEARCH_BAR_DATA_KEY: 'searchBarData',
  US_CHAT_HISTORY: 'ChatStore',
  US_PARENT_OBJECT: 'US_PARENT_OBJECT',
  US_SITTER_OBJECT: 'US_SITTER_OBJECT',
  US_USER_AUTH_TOKEN: 'US_USER_AUTH_TOKEN',
  US_USER_OBJECT: 'US_USER_OBJECT',
  US_USER_REFRESH_TOKEN: 'US_USER_REFRESH_TOKEN',
  US_USER_TESTS_OBJECT: 'US_USER_TESTS_OBJECT',
  UUID: 'usUuid',

  // Redirect logic
  REDIRECT_URL: 'redirectTo',

  // Signup
  SIGN_UP_ORIGIN: 'marketing_inbound_url',
  SIGN_UP_RECURRING: 'signupRecurring',
  SIGN_UP_SEARCH: 'personalizeSearchModal',
  SIGN_UP_VOUCHER: 'signup_promo_voucher_code',
};
